import React, { useState } from "react";

export default ({ user = {}, className, ...props }) => {
  const [error, setError] = useState(false);
  function returnUserName() {
    let nome = user.name ? user.name : user.nome ? user.nome : null;

    if (nome) {
      const nomes = nome.trim().split(" ");
      const primeiraLetra = nomes[0]?.[0]?.toUpperCase() || "";
      const terceiraLetra = nomes[2]?.[0]?.toUpperCase() || nomes[1]?.[0]?.toUpperCase() || "";
      return <strong>{primeiraLetra + terceiraLetra}</strong>;
    } else {
      return <></>;
    }
  }

  function Preview() {
    if (error) return returnUserName();
    if (user && user.logo_url) {
      // comentado para realizar um teste de fluxo de imagens no AWS
      return (
        <img
          style={{
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
          alt="avatar"
          src={`${user.logo_url}`}
          onError={() => setError(true)}
        />
      );

    } else {
      if (user && (user.name || user.nome)) {
        return returnUserName();
      }
    }
    return <></>;
  }

  return (
    <a
      className={` avatar rounded-circle ${className}`}
      style={{
        color: "#fff",
        ...props.style,
      }}
      href="#"
      onClick={(e) => e.preventDefault()}
      {...props}
    >
      <Preview />
      {props.children}
    </a>
  );
};
